const _temp0 = require("./01-PriorityBatch.json");
const _temp1 = require("./02-ReadyBatch.json");
module.exports = {
  "01-PriorityBatch": _temp0,
  "02-ReadyBatch": _temp1
}